import React, { useEffect } from "react";
import Customer from "../../../components/Admin/User/Customer";
import Staff from "../../../components/Admin/User/Staff";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AdminLayout from "../../../components/Admin/Layout";
import Company from "../../../components/Admin/User/Company";

const pathPrefix = "/admin/users";

const AdminUserPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== pathPrefix) return;
    navigate(`${pathPrefix}/customers`);
  }, [location.pathname]);

  return (
    <AdminLayout
      title={"Users"}
      tabs={[
        { id: 0, title: "Customers", path: `${pathPrefix}/customers` },
        { id: 1, title: "Companies", path: `${pathPrefix}/companies` },
        { id: 2, title: "Staffs", path: `${pathPrefix}/staffs` },
      ]}
    >
      <Routes>
        <Route path="/customers" element={<Customer />} />
        <Route path="/companies" element={<Company />} />
        <Route path="/staffs" element={<Staff />} />
      </Routes>
    </AdminLayout>
  );
};

AdminUserPage.propTypes = {};

export default AdminUserPage;
